"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormRow = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var O = __importStar(require("fp-ts/Option"));
var function_1 = require("fp-ts/function");
var React = __importStar(require("react"));
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var FieldFormatter_1 = require("../FieldFormatter");
var FlexView_1 = require("../FlexView");
var Icon_1 = require("../Icon");
var TextFormatter_1 = require("../TextFormatter");
var nameFieldsBuilder_1 = require("./nameFieldsBuilder");
require("./formRow.css");
var FormRow = /** @class */ (function (_super) {
    __extends(FormRow, _super);
    function FormRow(props) {
        var _this = _super.call(this, props) || this;
        _this.onFocus = function (event) {
            return (0, function_1.pipe)(O.fromNullable(_this.props.helpers), O.map(function (h) {
                switch (h.type) {
                    case 'single':
                        return _this.onChange$.next(O.some(h.help));
                    case 'multiple':
                        (0, function_1.pipe)(O.fromNullable(event.nativeEvent.target), 
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        O.chainNullableK(function (e) { return e.name; }), O.map(function (n) { return (0, nameFieldsBuilder_1.getFieldNameRaffined)(n); }), O.chainNullableK(function (name) { return h.helps[name]; }), O.map(function (help) { return _this.onChange$.next(O.some(help)); }));
                }
            }));
        };
        _this.printHelper = function (help) {
            return ((0, jsx_runtime_1.jsxs)("span", __assign({ className: "form-row-right-helper" }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "form-row-right-helper_arrow" }, { children: [(0, jsx_runtime_1.jsx)("div", { className: "form-row-right-helper_arrow_border" }), (0, jsx_runtime_1.jsx)("div", { className: "form-row-right-helper_arrow_fill" })] })), (0, jsx_runtime_1.jsxs)(FlexView_1.FlexView, __assign({ gutters: { r: 'sm', b: 'mi' }, vAlignContent: "center", flowDirection: { xs: 'row' } }, { children: [(0, jsx_runtime_1.jsx)(FlexView_1.FlexView.Item, __assign({ xs: true }, { children: (0, jsx_runtime_1.jsx)(TextFormatter_1.TextFormatter, __assign({ borderless: true, fontWeight: "bold" }, { children: (0, jsx_runtime_1.jsx)(FieldFormatter_1.FieldFormatter.Color, __assign({ color: "primary" }, { children: help.title })) })) })), (0, jsx_runtime_1.jsx)(FlexView_1.FlexView.Item, { children: (0, jsx_runtime_1.jsx)(Icon_1.Icon, { icon: "icon_info_light", size: "lg" }) })] })), (0, jsx_runtime_1.jsx)(TextFormatter_1.TextFormatter, __assign({ borderless: true }, { children: help.body }))] })));
        };
        _this.addFocus = function () {
            return typeof _this.props.helpers !== 'undefined'
                ? {
                    onFocus: _this.onFocus,
                    onBlur: function () {
                        _this.onChange$.next(O.none);
                    },
                }
                : {};
        };
        _this.onChange$ = new rxjs_1.Subject();
        _this.subscription = O.none;
        _this.state = {
            help: O.none,
        };
        return _this;
    }
    FormRow.prototype.componentDidMount = function () {
        var _this = this;
        this.subscription = O.some(this.onChange$.pipe((0, operators_1.debounceTime)(100)).subscribe(function (help) { return _this.setState({ help: help }); }));
    };
    FormRow.prototype.componentWillUnmount = function () {
        (0, function_1.pipe)(this.subscription, O.map(function (s) { return s.unsubscribe(); }));
    };
    FormRow.prototype.render = function () {
        return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "form-row" }, this.addFocus(), { children: [this.props.children, (0, function_1.pipe)(this.state.help, O.map(this.printHelper), O.toNullable)] })));
    };
    return FormRow;
}(React.PureComponent));
exports.FormRow = FormRow;
//# sourceMappingURL=FormRow.js.map